/** Palantir-inspired design tokens for Lighthouse */

export const colors = {
  void: "#090A0C",
  base: "#0E1014",
  elevated: "#14171C",
  panel: "#1A1E26",
  hover: "#222733",
  border: "#2A303C",
  borderSubtle: "#1F242E",

  textPrimary: "#E8ECF2",
  textSecondary: "#8B93A7",
  textTertiary: "#5C6578",

  signal: "#5EB8D4",
  signalDim: "#2A6F84",
  signalMuted: "rgba(94, 184, 212, 0.15)",

  brandMark: "#C45B7A",
  success: "#3D9B6E",
  successMuted: "rgba(61, 155, 110, 0.18)",
  warning: "#D4A054",
  warningMuted: "rgba(212, 160, 84, 0.18)",
  danger: "#C45C5C",
  dangerMuted: "rgba(196, 92, 92, 0.18)",
} as const;

/** Deterministic chart palette — cool industrial, high contrast on dark */
export const chartPalette = [
  "#5EB8D4",
  "#D4A054",
  "#3D9B6E",
  "#C45B7A",
  "#7B8CDE",
  "#6B9B8E",
  "#B8956C",
  "#8B93A7",
] as const;

export const chartColors = {
  primary: chartPalette[0],
  secondary: chartPalette[1],
  success: chartPalette[2],
  danger: chartPalette[3],
  warning: "#D4A054",
  muted: "#5C6578",
  axis: "#5C6578",
  grid: "#1F242E",
} as const;

export const getChartColor = (index: number): string =>
  chartPalette[index % chartPalette.length];
